import { i18n } from '@/locale'

const required = (v) => Boolean(v) || i18n.t('error.form.required')
const isURL = (url) => {
  const pattern = /^((http(s)?:\/\/(www\.)?)|(localhost))((localhost|\d{1,3}\.\d{1,3}\.\d{1,3}\.\d{1,3})(:\d+)?|(([a-zA-Z0-9]+(-?[a-zA-Z0-9])*\.)+[\w]{2,}))(\/\S*)?$/gi
  return pattern.test(url) || false
}
const isEmail = (v) => !v || (/.+@.+\..+/.test(v) || i18n.t('error.form.email_format'))
const zeroOrMore = (v) => parseInt(v) >= 0 || i18n.t('error.form.min_value', { minValue: 0 })
const moreThanZero = (v) => v >= 1 || i18n.t('error.form.min_value', { minValue: 1 })


export {
  required,
  isURL,
  isEmail,
  zeroOrMore,
  moreThanZero,
}
